import { useContext } from "react";
import Context from "./Context";

const useVisitorContext = () => useContext(Context);

export default useVisitorContext;
